const values = [
  {
    icon: "ri-shield-check-line",
    title: "Ética e Integridade",
    text: "Atuamos com total transparência e compromisso ético em cada caso que representamos.",
  },
  {
    icon: "ri-lightbulb-line",
    title: "Estratégia Jurídica",
    text: "Cada caso é analisado com profundidade, construindo estratégias sólidas e personalizadas.",
  },
  {
    icon: "ri-heart-line",
    title: "Atendimento Humanizado",
    text: "Tratamos cada cliente com atenção individual, compreendendo suas necessidades com empatia.",
  },
  {
    icon: "ri-trophy-line",
    title: "Foco em Resultados",
    text: "Nosso compromisso é defender seus interesses com dedicação e buscar os melhores desfechos.",
  },
];

export default function Escritorio() {
  return (
    <section id="escritorio" className="bg-[#6E0C10] py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Label */}
        <div className="flex items-center gap-4 mb-4">
          <div className="h-px w-12 bg-[#E3B24A]/60" />
          <span className="text-[#E3B24A] font-body text-xs tracking-[0.3em] uppercase font-medium">
            Sobre nós
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Text */}
          <div>
            <h2 className="font-heading text-4xl md:text-5xl font-semibold text-white leading-tight mb-6">
              O Escritório
            </h2>
            <div className="w-16 h-0.5 bg-[#E3B24A] mb-8" />

            <p className="font-body text-[#F2D27A]/80 text-base md:text-lg leading-relaxed mb-6">
              O escritório <strong className="text-[#F2D27A]">Lupepsa &amp; Marconatto</strong> atua com compromisso, ética e um olhar humano para as necessidades de cada cliente. Com mais de 8 anos de atuação, nossa trajetória é marcada pela busca incansável pela garantia de direitos e pela construção de soluções jurídicas eficientes e personalizadas.
            </p>
            <p className="font-body text-[#F2D27A]/80 text-base leading-relaxed mb-10">
              Nosso propósito é unir conhecimento técnico e acolhimento, transformando a complexidade jurídica em caminhos acessíveis e resultados concretos.
            </p>

            {/* Values Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {values.map((v) => (
                <div
                  key={v.title}
                  className="flex items-start gap-4 group"
                >
                  <div className="w-10 h-10 flex items-center justify-center rounded-full border border-[#E3B24A]/40 bg-[#E3B24A]/10 flex-shrink-0 group-hover:bg-[#E3B24A]/20 transition-colors duration-300">
                    <i className={`${v.icon} text-[#E3B24A] text-lg`} />
                  </div>
                  <div>
                    <h3 className="font-body font-semibold text-[#F2D27A] text-sm mb-1">{v.title}</h3>
                    <p className="font-body text-[#F2D27A]/60 text-sm leading-relaxed">{v.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Photo */}
          <div className="relative">
            <div className="absolute -top-4 -left-4 w-full h-full border border-[#E3B24A]/30 rounded-lg" />
            <div className="relative rounded-lg overflow-hidden w-full h-[480px] md:h-[560px]">
              <img
                src="https://storage.readdy-site.link/project_files/761f9a53-7d6d-4162-b8bb-9f472548236c/fa7af8a5-3ca3-44a5-85c6-c3f4eab7418c_WhatsApp-Image-2026-03-26-at-11.35.34.jpeg?v=d3b24da8d8ba210c2fd6f1ec2308d24b"
                alt="Advogados Lupepsa & Marconatto"
                className="w-full h-full object-cover object-top"
              />
              {/* Overlay gradient */}
              <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-[#6E0C10]/60 to-transparent" />
            </div>
            {/* Decorative corner element */}
            <div className="absolute -bottom-4 -right-4 w-24 h-24 border-b-2 border-r-2 border-[#E3B24A]/50 rounded-br-lg" />
          </div>
        </div>
      </div>
    </section>
  );
}
